import { AppStoreConfig } from '@ddt-web/data-service';

export const ModelsExperienceStoreConfig: AppStoreConfig = {};

export const StoreFeatureName = 'modelsExperienceStore';
